import type {
  ErrorBannerState,
  OAuthConfirmationState,
  OAuthProvider,
  RequestAccessDialogState,
} from '../types';

export const LINK_PROVIDER_ACTION_ID = 'integrations.link-provider';
export const REQUEST_ACCESS_ACTION_ID = 'integrations.request-access';

export const INITIAL_CONFIRMATION_STATE: OAuthConfirmationState = {
  isOpen: false,
  provider: null,
  metadata: null,
};

export const INITIAL_REQUEST_ACCESS_STATE: RequestAccessDialogState = {
  isOpen: false,
  login: '',
};

export const INITIAL_ERROR_BANNER_STATE: ErrorBannerState = {
  isVisible: false,
  message: '',
  canRetry: false,
  provider: null,
};

export const OAUTH_START_PATHS: Record<OAuthProvider, string> = {
  github: '/api/integrations/github/oauth/start',
  microsoft: '/api/integrations/microsoft/oauth/start',
  linear: '/api/integrations/linear/oauth/start',
  notion: '/api/integrations/notion/oauth/start',
};

// TODO(M11-005): durable home is the Provider.oauthConfig policy projection (FR9).
// Stop-gap discriminator for the client-side admin-consent pre-flight gate.
export const ADMIN_CONSENT_PROVIDERS: readonly OAuthProvider[] = ['microsoft'];
